import { Component, OnInit } from '@angular/core';
import { CommonCertificatAssuranceComponent } from '@kv-common-components/kv-common-components';
import {
    AuthenticationService,
    EspaceClientService,
    EspaceDocumentaireService,
    User,
} from '@kv-common-components/kx-services';
import { NGXLogger } from 'ngx-logger';
import { AssuranceHelperService } from '@shared/services/assurance-helper.service';
import { RouterHelperService } from '@shared/services/router-helper.service';
import * as moment from 'moment';

@Component({
    selector: 'app-finalisation',
    templateUrl: './finalisation.component.html',
    styleUrls: ['./finalisation.component.scss'],
})
export class FinalisationComponent
    extends CommonCertificatAssuranceComponent
    implements OnInit
{
    personne: any;
    idPropositionPrincipale: string;
    allDocuments: any[];

    certificatAssurance: any;
    docsAdhesionSignes: any;

    certificatTypologies: string[] = ['ADH3021', 'ADH3044', 'ADH3244'];
    // used to get the right liasseAdhesion (BAQS)
    regexBAQSTypologies = /^(BAQS )(.+)( ELECTRONIQUE| MANUEL| AUTOMATIQUE)$/;
    regexPaContract = /^(PA )(CONTRAT|contrat)(.+)$/;
    isLoading = false;
    contextDossier: any;
    isEcretementValue = false;
    finalisationPageTitle: string;
    currentStepId = 'decision_assureur';
    espaceClient: any;
    isFinalisationAfterPropoSignature: boolean;

    constructor(
        protected logger: NGXLogger,
        protected espaceDocumentaireService: EspaceDocumentaireService,
        private authenticationService: AuthenticationService,
        private espaceClientService: EspaceClientService,
        private routerHelperService: RouterHelperService
    ) {
        super(logger, espaceDocumentaireService);
    }

    ngOnInit() {
        this.isLoading = true;
        this.logger.debug('Client is accessing Finalisation Component');
        const currentUser: User = this.authenticationService.currentUserValue;
        this.espaceClientService
            .getEspaceClient(currentUser.idPersonne)
            .subscribe((espaceClient) => {
                this.espaceClient = espaceClient;
                this.personne = espaceClient.personne;
                this.idPropositionPrincipale =
                    currentUser.idPropositionPrincipale;
                this.espaceDocumentaireService
                    .getEspaceDocumentaire(
                        this.personne.idPersonne,
                        this.idPropositionPrincipale
                    )
                    .subscribe((espaceDocumentaire) => {
                        this.allDocuments = espaceDocumentaire;
                        this.setDocs();
                        this.isLoading = false;
                    });

                this.contextDossier =
                    this.routerHelperService.initializeContextDossier(
                        this.espaceClient
                    );
                this.isFinalisationAfterPropoSignature =
                    AssuranceHelperService.isCodeAiaStatutDAForFinalisationAfterPropoSignature(
                        this.contextDossier.emprunteur.assurance.statutDA
                    );
                this.handleEcretement(this.contextDossier);
            });
    }

    handleEcretement(contextDossier: any) {
        const currentAssurance = contextDossier.emprunteur.assurance;
        if (
            currentAssurance.statutEcretement ===
                AssuranceHelperService.statutEcretementEligible &&
            AssuranceHelperService.isCodeAiaStatutDAForSignaturePropo(
                currentAssurance.statutDA
            )
        ) {
            this.isEcretementValue = true;
            this.finalisationPageTitle = 'finalisation.ecretement.title';
            this.currentStepId = 'signature_propo';
        } else {
            this.finalisationPageTitle = 'finalisation.header.title';
        }
    }

    private setDocs() {
        this.logger.debug({ allDocs: this.allDocuments });
        this.certificatAssurance = this.allDocuments.find((doc) =>
            this.certificatTypologies.includes(doc.typologie)
        );
        const paContractDocument = this.findDocumentByRegex(
            this.regexPaContract,
            this.allDocuments
        );
        this.docsAdhesionSignes =
            paContractDocument ||
            this.findDocumentByRegex(
                this.regexBAQSTypologies,
                this.allDocuments
            );
    }

    private findDocumentByRegex(regex: RegExp, allDocuments: any[]): any {
        // most recent docs first
        allDocuments.sort((docA: any, docB: any) =>
            moment(docB.dateDepot, 'YYYY-MM-DDThh:mm:ss').diff(
                moment(docA.dateDepot, 'YYYY-MM-DDThh:mm:ss')
            )
        );
        return allDocuments.find((doc) => regex.test(doc.typologie));
    }
}
